import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Logo } from './Logo';
import { navLinks } from '../data/site';
export function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Escape closes the menu; lock body scroll while it is open
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled || open ? 'border-b border-line bg-paper/90 backdrop-blur-md' : 'border-b border-transparent'}`} data-id="element-71" data-mp="1k6fe0q54i3hs">
      <nav aria-label="Primary" className="mx-auto flex h-[68px] max-w-[1240px] items-center justify-between px-6 md:px-10" data-id="element-72" data-mp="2cw5w1a9vlpj6">
        <Link to="/" aria-label="NexLaw — home" className="shrink-0" data-id="element-73" data-mp="2351i8dvxsapx">
          <Logo size="sm" data-id="element-74" data-mp="234rqolv8tvi4" />
        </Link>

        <ul className="hidden items-center gap-8 lg:gap-9 md:flex" data-id="element-75" data-mp="30k5ocemu5nzv">
          {navLinks.slice(0, 4).map(link => <li key={link.to} data-id="element-76" data-mp="2vtfiz1eetl56">
              <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `relative py-1 text-[14px] transition-colors hover:text-ink ${isActive ? 'text-ink' : 'text-mist'}`} data-id="element-77" data-mp="2vse3mkqd2chn">
                {({
              isActive
            }) => <>
                    {link.label}
                    <span aria-hidden="true" className={`absolute -bottom-0.5 left-0 h-px w-full origin-left bg-navy transition-transform duration-300 ${isActive ? 'scale-x-100' : 'scale-x-0'}`} data-id="element-78" data-mp="p33r61z7cbq4" />
                  </>}
              </NavLink>
            </li>)}
        </ul>

        <div className="flex items-center gap-1" data-id="element-79" data-mp="1vliq9i4pt757">
          <Link to="/contact" className="hidden rounded-full bg-ink px-5 py-2.5 text-[13.5px] font-medium text-paper transition-colors hover:bg-navy md:inline-flex" data-id="element-80" data-mp="1vmts3celo4to">
            Contact
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="-mr-2.5 flex h-11 w-11 items-center justify-center text-ink md:hidden" data-id="element-81" data-mp="2am65tmjzz3ii">
            {open ? <CloseIcon fontSize="small" data-id="element-82" data-mp="2te8n904gqntt" /> : <MenuIcon fontSize="small" data-id="element-83" data-mp="2td6zbv2cm6uo" />}
          </button>
        </div>
      </nav>

      <div id="mobile-menu" hidden={!open} className="max-h-[calc(100vh-68px)] overflow-y-auto border-t border-line bg-paper md:hidden" data-id="element-84" data-mp="2of5htekkmflb">
        <ul className="px-6 pb-2 pt-2" data-id="element-85" data-mp="2ydlbnpazg2yi">
          {navLinks.map(link => <li key={link.to} className="border-b border-line/70 last:border-0" data-id="element-86" data-mp="181p59zu5a6jh">
              <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `block py-4 font-display text-[20px] tracking-tight transition-colors ${isActive ? 'text-ink' : 'text-graphite'}`} data-id="element-87" data-mp="183rtcebqlplk">
                {link.label}
              </NavLink>
            </li>)}
        </ul>
        <div className="px-6 pb-8 pt-4" data-id="element-88" data-mp="1jhjyoxml75dn">
          <Link to="/contact" className="flex w-full items-center justify-center rounded-full bg-ink px-6 py-3.5 text-[15px] font-medium text-paper" data-id="element-89" data-mp="1jgidw1frr4iq">
            Contact us
          </Link>
        </div>
      </div>
    </header>;
}